import React from 'react';
import { API, View } from '@gin-betting/core';
import cd from 'debug';

import { TITLES_BY_SPECIFIER } from 'app-constants';
import { MarketTitle } from 'components';
import { getSignedSpecifierPair } from 'utils';
import { MarketHcpRow } from '../MarketHcpRow';
import { getHcpSpecifier } from '../MarketsValue/utils';

import './MarketHcp.scss';

const debug = cd('match-list:components:MarketHcp');

export interface OwnProps {
    market: View.Market;
    hasMatchHeader?: boolean;
    isDefaultName?: boolean;
}

type Props = OwnProps;

const MarketHcp: React.FC<Props> = props => {
    debug('render', props);
    const { market, hasMatchHeader, isDefaultName } = props;

    const { specifiers, name, odds } = market;

    const specifier = getHcpSpecifier(specifiers);

    const [firstValue, secondValue] = getSignedSpecifierPair(
        specifier ? specifier.value : null
    );

    return (
        <div styleName="container" className="__app-MarketHcp-container ">
            {hasMatchHeader && (
                <MarketTitle
                    name={isDefaultName ? '' : name}
                    defaultMsg={TITLES_BY_SPECIFIER.handicap}
                />
            )}
            <MarketHcpRow oddId={odds[0]} value={firstValue} />
            <MarketHcpRow oddId={odds[1]} value={secondValue} />
        </div>
    );
};

const defaultProps: Required<Pick<Props, 'market'>> = {
    market: {
        id: '',
        priority: 0,
        status: API.MarketStatus.SUSPENDED,
        odds: ['', ''],
        name: '',
        specifiers: [],
        typeId: -999,
        tags: [],
    },
};

MarketHcp.defaultProps = defaultProps;

export default React.memo(MarketHcp);
